import { Pipe, PipeTransform } from '@angular/core';

const PADDING = '00000000000000000';

@Pipe({ name: 'axisInputNumberPipe' })
export class AxisInputNumberPipe implements PipeTransform {
  transform(value: string, settings): string {
    const _RegExp: RegExp = /^[0]+/;
    if (value || parseInt(value, 10) === 0) {
      if (settings.decimal_separator) {
        value = value.toString().replace('.', settings.decimal_separator);
      }
      value = value || parseInt(value, 10) === 0 ? value : '';

      let integer, fraction = '';
        const newValue = value
          .toString()
          .replace(settings.prefix, '')
          .replace(settings.suffix, '');

        let index = newValue.lastIndexOf('.');
        if (index >= 0) {
          integer = newValue.substr(0, index).split(settings.thousands_separator)
            .join('').split(',')
            .join('');
          fraction = newValue.substr(index + 1, newValue.length);
        } else {
          index = newValue.lastIndexOf(settings.decimal_separator);
          if (index >= 0) {
            integer = newValue.substr(0, index).split(settings.thousands_separator)
              .join('').split(',')
              .join('');
            fraction = newValue.substr(index + 1, newValue.length);
          } else {
            integer = newValue.split(settings.thousands_separator)
              .join('').split(',')
              .join('');
          }
        }

      if (integer.includes('.') === false) {
        integer = integer.replace(_RegExp, '');
      }
      if (_RegExp.test(integer) || integer.length === 0) {
        integer = integer.replace(integer, '0');
      }
      if (fraction) {
        let loop = true;
        while (fraction && loop) {
          const lastChar = fraction[fraction.length - 1];
          loop = PADDING.indexOf(lastChar) >= 0;
          if (loop) {
            fraction = fraction.substr(0, fraction.length - 1);
          }
        }
        if (fraction) {
          fraction = (settings.decimal_separator || '.') + fraction;
        }
      }

      // value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, settings.thousands_separator);
      let prefixVal: string;
      let suffixVal: string;
      if (value === '') {
        prefixVal = '';
        suffixVal = '';
      } else {
        prefixVal = settings.prefix || '';
        suffixVal = settings.suffix || '';
      }
      let integerFractVal = integer + (fraction || '');
      let finalVal;
      if (settings.decimal_separator && settings.decimal_separator !== '.') {
        integerFractVal = integerFractVal.toString().replace(settings.decimal_separator, '.');
      }

      if (settings.round === 0 || settings.round < 0) {
        finalVal =
          settings.round === 0
            ? Math.round(Number(integerFractVal))
            : this.decimalAdjust('round', integerFractVal, settings.round);
      } else if (settings.floor === 0 || settings.floor < 0) {
        finalVal =
          settings.floor === 0
            ? Math.floor(Number(integerFractVal))
            : this.decimalAdjust('floor', integerFractVal, settings.floor);
      } else if (settings.ceil === 0 || settings.ceil < 0) {
        finalVal =
          settings.ceil === 0
            ? Math.ceil(Number(integerFractVal))
            : this.decimalAdjust('ceil', integerFractVal, settings.ceil);
      } else {
        finalVal = integerFractVal;
      }
      if (settings.fraction_size === 0 || settings.fraction_size) {
        let integerValue, fractionValue = '';
        const newFinalValue = finalVal
          .toString()
          .replace(settings.prefix, '')
          .replace(settings.suffix, '');

        let newIndex = newFinalValue.lastIndexOf('.');
        if (newIndex >= 0) {
          integerValue = newFinalValue.substr(0, newIndex).split(settings.thousands_separator)
            .join('').split(',')
            .join('');
          fractionValue = newFinalValue.substr(newIndex + 1, newFinalValue.length);
        } else {
          newIndex = newFinalValue.lastIndexOf(settings.decimal_separator);
          if (newIndex >= 0) {
            integerValue = newFinalValue.substr(0, newIndex).split(settings.thousands_separator)
              .join('').split(',')
              .join('');
            fractionValue = newFinalValue.substr(newIndex + 1, newFinalValue.length);
          } else {
            integerValue = newFinalValue.split(settings.thousands_separator)
              .join('').split(',')
              .join('');
          }
        }
        if (_RegExp.test(integerValue)) {
          integerValue = integerValue.replace(/^0+/, '');
          if (integerValue.length === 0) {
            integerValue = integerValue.replace(integerValue, '0');
          }
        }
        fractionValue =
          settings.fraction_size > 0
            ? settings.decimal_separator +
            (fractionValue + (settings.noTrailingZeros ? '' : PADDING)).substring(0, settings.fraction_size)
            : '';
        integerValue = integerValue.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          settings.thousands_separator
        );
        finalVal = integerValue + (fractionValue && fractionValue !== settings.decimal_separator ? fractionValue : '');
      }
      if (settings.decimal_separator && settings.decimal_separator !== '.') {
        finalVal = finalVal.toString().replace('.', settings.decimal_separator);
      }
      integer = finalVal
        .toString()
        .split(settings.decimal_separator)[0]
        .replace(/\B(?=(\d{3})+(?!\d))/g, settings.thousands_separator);
      fraction = finalVal
        .toString()
        .split(
          settings.decimal_separator
        )[1] ? settings.decimal_separator + finalVal
          .toString()
          .split(settings.decimal_separator)[1] : '';
      const finalValue = integer + fraction;
      return prefixVal + finalValue + suffixVal;
      // return prefixVal + integer + fraction  + suffixVal;
    } else {
      return '';
    }
  }

  parse(value: string, settings): string {
    if (value || parseInt(value, 10) === 0) {
      const thousandsSeparator = settings.thousands_separator
        ? settings.thousands_separator
        : ',';
      const decimalSeparator = settings.decimal_separator
        ? settings.decimal_separator
        : '.';


      let integer, fraction = '';
      const newValue = value
        .toString()
        .replace(settings.prefix, '')
        .replace(settings.suffix, '');

      let index = newValue.lastIndexOf('.');
      if (index >= 0) {
        integer = newValue.substr(0, index).split(thousandsSeparator)
          .join('').split(',')
          .join('');
        fraction = newValue.substr(index + 1, newValue.length);
      } else {
        index = newValue.lastIndexOf(decimalSeparator);
        if (index >= 0) {
          integer = newValue.substr(0, index).split(thousandsSeparator)
            .join('').split(',')
            .join('');
          fraction = newValue.substr(index + 1, newValue.length);
        } else {
          integer = newValue.split(thousandsSeparator)
            .join('').split(',')
            .join('');
        }
      }
      if (fraction) {
        let loop = true;
        while (fraction && loop) {
          const lastChar = fraction[fraction.length - 1];
          loop = PADDING.indexOf(lastChar) >= 0;
          if (loop) {
            fraction = fraction.substr(0, fraction.length - 1);
          }
        }
        if (fraction) {
          fraction = (decimalSeparator || '.') + fraction;
        }
      }
      integer = integer + fraction;
      if (decimalSeparator && decimalSeparator !== '.') {
        integer = integer.toString().replace(decimalSeparator, '.');
      }
      let finalValue;
      if (!settings.view_roundoff) {
        if (settings.round === 0 || settings.round) {
          finalValue =
            settings.round === 0
              ? Math.round(Number(integer))
              : this.decimalAdjust('round', integer, settings.round);
        } else if (settings.floor === 0 || settings.floor) {
          finalValue =
            settings.floor === 0
              ? Math.floor(Number(integer))
              : this.decimalAdjust('floor', integer, settings.floor);
        } else if (settings.ceil === 0 || settings.ceil) {
          finalValue =
            settings.ceil === 0
              ? Math.ceil(Number(integer))
              : this.decimalAdjust('ceil', integer, settings.ceil);
        } else {
          finalValue = integer;
        }
      } else {
        finalValue = integer;
      }
      if (settings.fraction_size === 0 || settings.fraction_size) {
        let integerValue,
          fractionValue = '';
        const newFinalValue = finalValue
          .toString()
          .replace(settings.prefix, '')
          .replace(settings.suffix, '');

        let indexNew = newFinalValue.lastIndexOf('.');
        if (indexNew >= 0) {
          integerValue = newFinalValue.substr(0, indexNew).split(thousandsSeparator)
            .join('').split(',')
            .join('');
          fractionValue = newFinalValue.substr(indexNew + 1, newFinalValue.length);
        } else {
          indexNew = newFinalValue.lastIndexOf(decimalSeparator);
          if (indexNew >= 0) {
            integerValue = newFinalValue.substr(0, indexNew).split(thousandsSeparator)
              .join('').split(',')
              .join('');
            fractionValue = newFinalValue.substr(indexNew + 1, newFinalValue.length);
          } else {
            integerValue = newFinalValue.split(thousandsSeparator)
              .join('').split(',')
              .join('');
          }
        }
        fractionValue =
          settings.fraction_size > 0
            ? decimalSeparator +
            (fractionValue + (settings.noTrailingZeros ? '' : PADDING)).substring(0, settings.fraction_size)
            : '';
            finalValue = integerValue + (fractionValue && fractionValue !== settings.decimal_separator ? fractionValue : '');
      }
      if (decimalSeparator && decimalSeparator !== '.') {
        finalValue = finalValue.toString().replace('.', decimalSeparator);
      }
      return finalValue;
    } else {
      return '';
    }
  }

  decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (
      value === null ||
      isNaN(value) ||
      !(typeof exp === 'number' && exp % 1 === 0)
    ) {
      return NaN;
    }

    if (value < 0) {
      return -this.decimalAdjust(type, -value, exp);
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
  }
}
